import http from '../http'

/**
 * 登录获取token
 * post方法，对应post请求
 * @param data
 * @returns {AxiosPromise}
 */
export function userLogin(param) {
  return http({
    url: '/api/auth/login',
    method: 'post',
    data: param
  })
}

/**
 * 获取登录用户信息
 * get方法，对应get请求
 * @returns {AxiosPromise}
 */
export function getAuth() {
  return http({
    url: '/api/auth/user/',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/untils/api/login.js